import { removeBundleItems } from './util.helpers.js'

// Handle bundle removal from cart
class BundleCartHandler {
  constructor() {
    this.init()
  }

  init() {
    // Listen for clicks on remove bundle buttons
    document.addEventListener('click', this.handleRemoveBundleClick.bind(this))
    
    // Listen for cart changes to update bundle indicators
    document.addEventListener('cart:change', this.updateBundleIndicators.bind(this))
    
    // Debug: Check if any bundle buttons exist
    setTimeout(() => {
      const bundleButtons = document.querySelectorAll('.line-item__remove-bundle-button')
    }, 1000)
  }

  async handleRemoveBundleClick(event) {
    
    if (!event.target.matches('.line-item__remove-bundle-button')) return
    
    event.preventDefault()
    const bundleId = event.target.dataset.bundleId
    
    
    if (!bundleId) {
      console.error('No bundle ID found')
      return
    }
    
    // Show loading state
    event.target.textContent = 'Removing...'
    event.target.disabled = true
    
    try {
      const result = await removeBundleItems(bundleId)
    } catch (error) {
      console.error('Failed to remove bundle:', error)
      event.target.textContent = 'Remove Bundle'
      event.target.disabled = false
      
      // Show error message if available
      if (window.themeVariables?.settings?.cartType === 'message') {
        document.dispatchEvent(new CustomEvent('toast:show', {
          detail: {
            message: 'Failed to remove bundle items',
            tone: 'error'
          }
        }))
      }
    }
  }

  updateBundleIndicators(event) {
    // Get all bundle items currently in cart
    const cart = event.detail.cart
    const bundleItems = cart.items.filter(item => 
      item.properties && item.properties._bundle
    )
    
    // Group by bundle ID
    const bundles = {}
    bundleItems.forEach(item => {
      const bundleId = item.properties._bundle
      if (!bundles[bundleId]) {
        bundles[bundleId] = []
      }
      bundles[bundleId].push(item)
    })
    
    // Update bundle indicators in the DOM
    document.querySelectorAll('[data-bundle-id]').forEach(lineItem => {
      const bundleId = lineItem.dataset.bundleId
      const bundleButton = lineItem.querySelector('.line-item__remove-bundle-button')
      
      if (bundleButton && bundles[bundleId]) {
        const bundleItemCount = bundles[bundleId].length
        bundleButton.textContent = `Remove Bundle (${bundleItemCount} items)`
      }
    })
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new BundleCartHandler())
} else {
  new BundleCartHandler()
}

export { BundleCartHandler }
